module.exports = __webpack_public_path__ + "assets/img/section-1-part3-born-to-be-wild.35e4a6f4.png";